import React from 'react';
import { Mail, Phone, ChevronLeft, ChevronRight, Briefcase } from 'lucide-react';

export default function EmployeeTable({ 
  employees, 
  meta, 
  currentPage, 
  setCurrentPage, 
  setPerPage, 
  onRowClick 
}) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-xs overflow-hidden flex flex-col flex-1">
      
      {/* Table Container */}
      <div className="overflow-x-auto flex-1">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50/70 text-[11px] font-bold text-slate-500 uppercase tracking-wider">
              <th className="py-3.5 px-6">Employee</th>
              <th className="py-3.5 px-6">Code</th>
              <th className="py-3.5 px-6">Email</th>
              <th className="py-3.5 px-6">Phone</th>
              <th className="py-3.5 px-6">Type</th>
              <th className="py-3.5 px-6">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 text-xs text-slate-700">
            {employees && employees.length > 0 ? (
              employees.map((emp) => (
                <tr 
                  key={emp.uuid || emp.id} 
                  onClick={() => onRowClick(emp)}
                  className="hover:bg-slate-50/80 transition cursor-pointer"
                >
                  <td className="py-3.5 px-6 flex items-center gap-3">
                    <div className="w-8 h-8 rounded-xl bg-blue-50 text-blue-600 border border-blue-100 font-extrabold flex items-center justify-center text-xs">
                      {emp.first_name?.[0]}{emp.last_name?.[0]}
                    </div>
                    <div>
                      <p className="font-bold text-slate-900">{emp.full_name || `${emp.first_name} ${emp.last_name}`}</p>
                      <p className="text-[10px] text-slate-400 capitalize">{emp.gender || 'N/A'}</p>
                    </div>
                  </td>
                  <td className="py-3.5 px-6 font-semibold text-slate-600">{emp.employee_code}</td>
                  <td className="py-3.5 px-6 text-slate-600">
                    <span className="flex items-center gap-1.5"><Mail className="w-3 h-3 text-slate-400" /> {emp.official_email || 'N/A'}</span>
                  </td>
                  <td className="py-3.5 px-6 text-slate-600">
                    <span className="flex items-center gap-1.5"><Phone className="w-3 h-3 text-slate-400" /> {emp.primary_phone || 'N/A'}</span>
                  </td>
                  <td className="py-3.5 px-6 text-slate-600 capitalize">
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-slate-100 border border-slate-200 rounded text-[10px] font-semibold">
                      <Briefcase className="w-2.5 h-2.5 text-slate-400" /> {emp.employment_type || 'N/A'}
                    </span>
                  </td>
                  <td className="py-3.5 px-6">
                    <span className={`px-2.5 py-1 rounded-full text-[10px] font-semibold border ${
                      emp.status === 'active' 
                        ? 'bg-emerald-50 text-emerald-600 border-emerald-200' 
                        : 'bg-amber-50 text-amber-600 border-amber-200'
                    }`}>
                      {emp.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="py-12 text-center text-slate-400 font-medium">
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer */}
      {meta && (
        <div className="p-4 border-t border-slate-200 bg-slate-50/50 flex items-center justify-between text-xs text-slate-600">
          <div>
            Showing page <span className="font-bold text-slate-900">{currentPage}</span> of <span className="font-bold text-slate-900">{meta.last_page || 1}</span>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="p-2 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition shadow-2xs cursor-pointer"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button
              onClick={() => setCurrentPage(prev => (meta.next_page_url ? prev + 1 : prev))}
              disabled={!meta.next_page_url && currentPage >= (meta.last_page || 1)}
              className="p-2 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition shadow-2xs cursor-pointer"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

    </div>
  );
}